// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  GameLevelItem,
  GameLevelService,
  GameLevelStatus,
} from '../../../../../../../services/game-level.service';
import { HWResourceService } from '../../../../../../../services/huawei-resource.service';

@Component({
    selector: 'app-game-level-form',
    templateUrl: './game-level-form.component.html',
    styleUrls: ['./game-level-form.component.scss'],
    standalone: false
})
export class GameLevelFormComponent implements OnInit {
  saving = false;
  loading = false;
  editId: number | null = null;

  form: {
    levelCode: string;
    name: string;
    cardImage: string;
    baseScore: number;
    questionCount: number;
    secondPerQuestion: number;
    timeBonus: number;
    victoryBonus: number;
    dailyLimit: number;
    ruleDescription: string | null;
    status: GameLevelStatus;
  } = {
    levelCode: '',
    name: '',
    cardImage: '',
    baseScore: 0,
    questionCount: 0,
    secondPerQuestion: 0,
    timeBonus: 0,
    victoryBonus: 0,
    dailyLimit: 0,
    ruleDescription: '',
    status: GameLevelStatus.ACTIVE,
  };

  readonly GameLevelStatus = GameLevelStatus;

  /** 仅给上传组件预览用：相对路径补 CDN，不修改公共 mediaUrlPipe */
  get cardImageUrlForPreview(): string {
    const url = this.form.cardImage;
    if (!url) {
      return '';
    }
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    const loc = new URL(window.location.href);
    const path = url.startsWith('/') ? url.substring(1) : url;
    return `${loc.protocol}//${HWResourceService.cdnHost}/${path}`;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private gameLevelSvc: GameLevelService,
    private msg: NzMessageService,
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.editId = +idParam;
      this.loadEdit();
    }
  }

  loadEdit(): void {
    if (!this.editId) {
      return;
    }
    this.loading = true;
    this.gameLevelSvc
      .list()
      .then((list: GameLevelItem[]) => {
        const row = list.find((r) => r.id === this.editId);
        if (!row) {
          this.msg.error('未找到该级别');
          this.router.navigate(['/admin/v3/game/levels']);
          return;
        }
        this.patchForm(row);
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  patchForm(row: GameLevelItem): void {
    const raw = row as GameLevelItem & { card_image?: string };
    const cardImage = raw.cardImage ?? raw.card_image ?? '';
    this.form = {
      levelCode: row.levelCode ?? '',
      name: row.name ?? '',
      cardImage,
      baseScore: row.baseScore ?? 0,
      questionCount: row.questionCount ?? 0,
      secondPerQuestion: row.secondPerQuestion ?? 0,
      timeBonus: row.timeBonus ?? 0,
      victoryBonus: row.victoryBonus ?? 0,
      dailyLimit: row.dailyLimit ?? 0,
      ruleDescription: row.ruleDescription ?? '',
      status: row.status === GameLevelStatus.INACTIVE ? GameLevelStatus.INACTIVE : GameLevelStatus.ACTIVE,
    };
  }

  cancel(): void {
    this.router.navigate(['/admin/v3/game/levels']);
  }

  onCardImageUploaded(evt: { url?: string }): void {
    if (evt && evt.url) {
      this.form.cardImage = evt.url;
    }
  }

  submit(): void {
    const code = (this.form.levelCode || '').trim();
    const name = (this.form.name || '').trim();
    if (!code) {
      this.msg.warning('请填写级别 code');
      return;
    }
    if (!name) {
      this.msg.warning('请填写级别名称');
      return;
    }
    if (code.length > 64) {
      this.msg.warning('级别 code 最长 64 字符');
      return;
    }
    if (name.length > 255) {
      this.msg.warning('级别名称最长 255 字符');
      return;
    }

    const payload = {
      levelCode: code,
      name,
      cardImage: this.form.cardImage ?? '',
      baseScore: Math.max(0, Math.floor(Number(this.form.baseScore)) || 0),
      questionCount: Math.max(0, Math.floor(Number(this.form.questionCount)) || 0),
      secondPerQuestion: Math.max(0, Math.floor(Number(this.form.secondPerQuestion)) || 0),
      timeBonus: Math.max(0, Math.floor(Number(this.form.timeBonus)) || 0),
      victoryBonus: Math.max(0, Math.floor(Number(this.form.victoryBonus)) || 0),
      dailyLimit: Math.max(0, Math.floor(Number(this.form.dailyLimit)) || 0),
      ruleDescription: this.form.ruleDescription === '' ? null : this.form.ruleDescription,
      status: this.form.status,
    };

    this.saving = true;
    const done = () => {
      this.saving = false;
    };

    if (this.editId) {
      this.gameLevelSvc
        .update(this.editId, payload)
        .then(() => {
          this.msg.success('保存成功');
          done();
          this.router.navigate(['/admin/v3/game/levels']);
        })
        .catch((err: any) => {
          done();
          this.msg.error(err?.message || '保存失败');
        });
    } else {
      this.gameLevelSvc
        .create(payload)
        .then(() => {
          this.msg.success('创建成功');
          done();
          this.router.navigate(['/admin/v3/game/levels']);
        })
        .catch((err: any) => {
          done();
          this.msg.error(err?.message || '创建失败');
        });
    }
  }
}
